/**
 * The machine's serial number, aka VIN (`Machines.serial_number`).
 *
 * A file of its own, depending on yup only: both `Machine.ts` and
 * `types/EuDataAct.ts` use it, and `Machine.ts` imports from `EuDataAct.ts`.
 */
import { string } from "yup"

export const MachineSerialNumberMaxLength = 100

/**
 * The machine's VIN, as sent by the frontend.
 *
 * It may be typed by the user, hence trimmed and upper-cased: VINs are stored
 * upper case, so normalising here means every caller of the API acts on the
 * canonical form, whatever it sent.
 */
export const MachineSerialNumberSchema = string()
  .trim()
  .uppercase()
  .required()
  .max(MachineSerialNumberMaxLength)
